import { configureStore } from '@reduxjs/toolkit';
import user from './user'
import mcode from './mcode'
import client from './client'
import project from './project'
import projectcost from './projectcost'
import comment from './comment'
import schedule from './schedule';
import scheduledownload from './scheduledownload';
import profile from './profile';
import projectstaff from './projectstaff';
import staffworkstatus from './staffworkstatus';

export const store = configureStore({
    reducer: {
        user: user,
        mcode:mcode,
        client:client,
        project:project,
        projectcost:projectcost,
        schedule:schedule,
        comment:comment,
        scheduledownload:scheduledownload,
        profile:profile,
        projectstaff:projectstaff,
        staffworkstatus:staffworkstatus,
    },
});
